import React from 'react'
import AppendSurgicalOrderLayout from 'presentation/patient/layouts/CreateSurgicalOrder/AppendSurgicalOrder'

export default function AddSurgicalOrder() {
  return <AppendSurgicalOrderLayout />
}
